<template>
  <div>
    <div class="step-header">
      <small>Etapa 5 de 5</small>
      <h5>Outras informações</h5>
      <small>Atenção: TODAS as perguntas são obrigatórias.</small>
    </div>

    <label>
      Você deseja ter liberdade financeira e ser dono do seu próprio
      negócio?
    </label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="desejaLibFinanceira"
          :value="'Sim'"
          v-on:change="updateValue($event, 'desejaLibFinanceira')"
        />
        <i class="helper" style="top: 3px;"></i>Sim
      </label>
      <label>
        <input
          type="radio"
          v-model="desejaLibFinanceira"
          :value="'Não'"
          v-on:change="updateValue($event, 'desejaLibFinanceira')"
        />
        <i class="helper" style="top: 3px;"></i>Não
      </label>
    </div>

    <label>
      Como você se sente em relação ao seu trabalho atual ou anterior,
      levando em consideração seu empenho e remuneração?
    </label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="sentimentoTrabalho"
          :value="'Trabalho muito e ganho pouco'"
          v-on:change="updateValue($event, 'sentimentoTrabalho')"
        />
        <i class="helper" style="top: 3px;"></i>Trabalho muito e ganho pouco
      </label>
      <label>
        <input
          type="radio"
          v-model="sentimentoTrabalho"
          :value="'Limitado pois não tenho plano de carreira'"
          v-on:change="updateValue($event, 'sentimentoTrabalho')"
        />
        <i class="helper" style="top: 3px;"></i>Limitado pois não tenho
        plano de carreira
      </label>
      <label>
        <input
          type="radio"
          v-model="sentimentoTrabalho"
          :value="'Ganho bem mas não tenho qualidade de vida'"
          v-on:change="updateValue($event, 'sentimentoTrabalho')"
        />
        <i class="helper" style="top: 3px;"></i>Ganho bem mas não tenho
        qualidade de vida
      </label>
      <label>
        <input
          type="radio"
          v-model="sentimentoTrabalho"
          :value="'Me sinto satisfeito com meu trabalho'"
          v-on:change="updateValue($event, 'sentimentoTrabalho')"
        />
        <i class="helper" style="top: 3px;"></i>Me sinto satisfeito com meu
        trabalho
      </label>
      <label>
        <input
          type="radio"
          v-model="sentimentoTrabalho"
          :value="'Nenhuma das alternativas'"
          v-on:change="updateValue($event, 'sentimentoTrabalho')"
        />
        <i class="helper" style="top: 3px;"></i>Nenhuma das alternativas
      </label>
    </div>

    <label>Você gosta de carros?</label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="gostaDeCarros"
          :value="'Gosto muito'"
          v-on:change="updateValue($event, 'gostaDeCarros')"
        />
        <i class="helper" style="top: 3px;"></i>Gosto muito
      </label>
      <label>
        <input
          type="radio"
          v-model="gostaDeCarros"
          :value="'Gosto'"
          v-on:change="updateValue($event, 'gostaDeCarros')"
        />
        <i class="helper" style="top: 3px;"></i>Gosto
      </label>
      <label>
        <input
          type="radio"
          v-model="gostaDeCarros"
          :value="'Não'"
          v-on:change="updateValue($event, 'gostaDeCarros')"
        />
        <i class="helper" style="top: 3px;"></i>Não
      </label>
    </div>

    <label>
      Algum amigo ou conhecido já pediu sua opinião sobre algum modelo de
      veículo que fosse comprar?
    </label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="pediuOpiniao"
          :value="'Com frequência'"
          v-on:change="updateValue($event, 'pediuOpiniao')"
        />
        <i class="helper" style="top: 3px;"></i>Com frequência
      </label>
      <label>
        <input
          type="radio"
          v-model="pediuOpiniao"
          :value="'Mais de uma vez'"
          v-on:change="updateValue($event, 'pediuOpiniao')"
        />
        <i class="helper" style="top: 3px;"></i>Mais de uma vez
      </label>
      <label>
        <input
          type="radio"
          v-model="pediuOpiniao"
          :value="'Sim'"
          v-on:change="updateValue($event, 'pediuOpiniao')"
        />
        <i class="helper" style="top: 3px;"></i>Sim
      </label>
      <label>
        <input
          type="radio"
          v-model="pediuOpiniao"
          :value="'Nunca'"
          v-on:change="updateValue($event, 'pediuOpiniao')"
        />
        <i class="helper" style="top: 3px;"></i>Nunca
      </label>
    </div>

    <label>
      Você conhece algum proprietário de loja de veículos e qual o padrão
      de vida dele?
    </label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="conheceProprietario"
          :value="'Conheço, padrão de vida altíssimo'"
          v-on:change="updateValue($event, 'conheceProprietario')"
        />
        <i class="helper" style="top: 3px;"></i>Conheço, padrão de vida
        altíssimo
      </label>
      <label>
        <input
          type="radio"
          v-model="conheceProprietario"
          :value="'Conheço, padrão de vida alto'"
          v-on:change="updateValue($event, 'conheceProprietario')"
        />
        <i class="helper" style="top: 3px;"></i>Conheço, padrão de vida alto
      </label>
      <label>
        <input
          type="radio"
          v-model="conheceProprietario"
          :value="'Conheço, padrão de vida bom'"
          v-on:change="updateValue($event, 'conheceProprietario')"
        />
        <i class="helper" style="top: 3px;"></i>Conheço, padrão de vida bom
      </label>
      <label>
        <input
          type="radio"
          v-model="conheceProprietario"
          :value="'Conheço, padrão de vida simples'"
          v-on:change="updateValue($event, 'conheceProprietario')"
        />
        <i class="helper" style="top: 3px;"></i>Conheço, padrão de vida
        simples
      </label>
      <label>
        <input
          type="radio"
          v-model="conheceProprietario"
          :value="'Não conheço'"
          v-on:change="updateValue($event, 'conheceProprietario')"
        />
        <i class="helper" style="top: 3px;"></i>Não conheço
      </label>
    </div>

    <label>
      Qual a sua expectativa para adquirir sua licença Vaapty Auto
      Traders?
    </label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="suaExpectativa"
          :value="'O quanto antes'"
          v-on:change="updateValue($event, 'suaExpectativa')"
        />
        <i class="helper" style="top: 3px;"></i>O quanto antes
      </label>
      <label>
        <input
          type="radio"
          v-model="suaExpectativa"
          :value="'Ainda estou analisando'"
          v-on:change="updateValue($event, 'suaExpectativa')"
        />
        <i class="helper" style="top: 3px;"></i>Ainda estou analisando
      </label>
      <label>
        <input
          type="radio"
          v-model="suaExpectativa"
          :value="'Não tenho pressa'"
          v-on:change="updateValue($event, 'suaExpectativa')"
        />
        <i class="helper" style="top: 3px;"></i>Não tenho pressa
      </label>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: [
    "desejaLibFinanceira",
    "sentimentoTrabalho",
    "gostaDeCarros",
    "pediuOpiniao",
    "conheceProprietario",
    "suaExpectativa"
  ],
  methods: {
    updateValue(event, data) {
      this.$emit(`update:${data}`, event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.step-header {
  margin-bottom: 30px;
}
</style>